module.exports = __webpack_public_path__ + "media/images/icons/filled/caret-right-3ca57f068fcbe41e0b36389dfe0142d9.svg";